<template>
    <section class="survey_section flex">

        <transition name="loading-fade">
            <CandidateSurveyLoading v-if="authStatus == 'loading'" />
        </transition>

        <CandidateTokenError v-if="authStatus == 'error'" />
        <CandidateAlreadyCompleted v-if="authStatus == 'alreadyCompleted'" />

        <CandidateSurvey v-if="authStatus == 'success'" />
        <CandidateResults v-if="authStatus == 'finish'" />


    </section>
</template>

<script>
import CandidateTokenError from "../components/new/candidateTokenError"
import CandidateSurvey from "../components/new/candidateSurvey"
import CandidateSurveyLoading from "../components/new/candidateSurveyLoading"
import CandidateAlreadyCompleted from "../components/new/candidateAlreadyCompleted"
import CandidateResults from "../components/new/candidateResults"


export default {
    name: 'SurveyNew',
    components: {
        CandidateTokenError,
        CandidateSurvey,
        CandidateSurveyLoading,
        CandidateAlreadyCompleted,
        CandidateResults
    },
    data(){
        return {}
    },
    computed: {
        authStatus(){
            return this.$store.state.CandidateStore.status
        }
    },
    beforeCreate(){
        this.$store.dispatch('CandidateStore/login', this.$route.params.evalToken).then((loginData) => {
            if(loginData){
                this.$i18n.locale = loginData.evaluation.language
            }
        })
    },
    methods: {

    }
}

</script>

<style lang="scss">
    .survey_section{
        background: $white;
    }
</style>
